/**
 * @FileDescription: 设置-地区
 * @Author: fanqixin
 * @Date: 2021-6-30 13:57:53
 * @LastEditors: fanqixin
 * @LastEditTime: 2021-6-30 13:57:53
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const DistrictApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/setting/district';
	},
	/**
	 * @description: 获取区域数据
	 * @param {Object} limit 参数条件，{ areaName, provinceId, hasProvince, hasCity }
	 * @param {Object} params params参数
	 */
	listDistrict: function(limit, params) {
		return axios.post(this.baseUrl() + "/listDistrict", limit, {
			params: Object.assign({
				whitelist: true
			}, params)
		});
	},
	/**
	 * @description: 获取区域列表
	 * @param {Object} params params参数
	 */
	queryAreaList: function(loading, params) {
		return this.listDistrict(null, Object.assign({
			loading: true
		}, params))
	},
	/**
	 * @description: 获取省/市集合
	 * @param {String} areaId 区域id
	 * @param {Boolean} hasCity 是否有市级子数据
	 * @param {Object} params params参数
	 */
	queryProvinceList: function(areaId, hasCity, params) {
		return this.listDistrict({
			areaName: areaId,
			hasProvince: true,
			hasCity: hasCity,
		}, Object.assign({
			loading: true
		}, params))
	},
	/**
	 * @description: 查询市列表
	 * @param {String} provinceId 省id
	 * @param {Object} params params参数
	 */
	queryCityList: function(provinceId, params) {
		return this.listDistrict({
			provinceId: provinceId
		}, Object.assign({
			loading: true
		}, params))
	}
};

export default Object.assign(DistrictApi, BaseApi);
